import React, { Component } from 'react';
import AnimationControls from '../common/AninamationControls';

import * as mouseEvents from '../../utils/mouseEvents';

export class Background extends Component {
	state = {
		colorset1: {
			'--background-color-1': 'rgba(221, 232, 255, 1)',
			'--background-color-2': 'rgba(229, 237, 255, 1)',
			'--background-color-3': 'rgba(239, 244, 255, 1)',
			'--background-color-4': 'rgba(255, 255, 255, 1)',
			'--text-color': '#000000'
		},
		colorset2: {
			'--background-color-1': 'rgba(20, 39, 38, 1)',
			'--background-color-2': 'rgba(25, 41, 43, 1)',
			'--background-color-3': 'rgba(31, 46, 55, 1)',
			'--background-color-4': 'rgba(36, 52, 71, 1)',
			'--text-color': '#ffffff'
		},
		isNight: false,
		opacity: 0.3,
		height: 1000
	};

	dayNightSwitch = () => {
		this.setState((prevState) => ({ isNight: !prevState.isNight }));
	};
	getColors = () => {
		return this.state.isNight ? this.state.colorset2 : this.state.colorset1;
	};
	getStyles = () => {
		return { ...this.getColors(), '--var-opacity': this.state.opacity, '--var-height': this.state.height + 'px' };
	};

	componentDidMount() {
		this.setHeight();
		// Reason i have this 100vh css property were causing problem in mobile browsers.
		// Browser's navigation bar is included to 100vh
		window.addEventListener('resize', this.setHeight.bind(this));
	}

	setHeight = () => {
		const height = window.innerHeight;
		this.setState({ height });
	};

	onMouseMoveHandler = (e) => {
		mouseEvents.onMouseMoveHandler.call(this, e);
	};

	render() {
		return (
			<div className="background" style={this.getStyles()} ref="container" onMouseMove={this.onMouseMoveHandler}>
				<AnimationControls onDayNightChange={this.dayNightSwitch} isDay={!this.state.isNight} />
				{this.props.children}
			</div>
		);
	}
}

export default Background;



// WEBPACK FOOTER //
// ./src/components/containers/Background.js